function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st1{stroke-width:3;stroke-miterlimit:10;}\n\t.st2{stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M25.3,25.1C18,39,22.6,56.2,35.9,64.7c1.9,1.2,3.9,2.2,6,2.9c4.2,1.5,8.6,2.1,13.1,1.6 c3.9-0.4,7.7-1.5,11.2-3.3L25.3,25.1z M19.8,43.2c-0.9-7.1,0.6-14.4,4.2-20.6c0.1-0.1,0.1-0.2,0.2-0.3c0.5-0.5,1.2-0.5,1.7,0l0,0 l43,43l0,0c0.1,0.1,0.1,0.2,0.2,0.2c0.3,0.6,0.1,1.3-0.4,1.6c-10.5,6.2-23.7,6-34-0.6c-2-1.3-3.9-2.8-5.6-4.5 C23.9,57,20.7,50.4,19.8,43.2L19.8,43.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M45.7,69.1l8.1,16.7c0.3,0.6,0,1.3-0.5,1.6l0,0c-0.2,0.1-0.3,0.1-0.5,0.1H22c-0.6,0-1.2-0.5-1.2-1.2 c0-0.2,0.1-0.4,0.2-0.6l11.3-22c0.3-0.6,1-0.8,1.6-0.5c0.1,0,0.1,0.1,0.2,0.1l0,0c2.4,1.8,5,3.2,7.8,4.2c0.5,0.2,1,0.3,1.5,0.5 s1,0.3,1.5,0.4C45.2,68.6,45.5,68.8,45.7,69.1L45.7,69.1z M50.8,85.1l-7-14.5l-1.1-0.3c-0.5-0.2-1-0.3-1.6-0.5c-1.5-0.6-3-1.2-4.4-2 c-1-0.5-2-1.1-3-1.7l-9.9,19.2L50.8,85.1z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M54.5,36.3c0.5-0.5,1.2-0.5,1.7,0s0.5,1.2,0,1.7L48,46.1c-0.5,0.5-1.2,0.5-1.7,0l0,0c-0.4-0.5-0.4-1.2,0-1.7 L54.5,36.3z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M58.7,33.8c-0.7-0.7-1.8-0.7-2.5,0s-0.7,1.8,0,2.5s1.8,0.7,2.5,0C59.4,35.7,59.4,34.5,58.7,33.8z M57.4,31  c2.3,0,4.1,1.9,4.1,4.2c0,1.1-0.4,2.1-1.2,2.8c-1.6,1.6-4.2,1.7-5.8,0.1c-1.6-1.6-1.7-4.2-0.1-5.8C55.2,31.4,56.3,31,57.4,31z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M61,27.9c-0.6,0.1-1.3-0.2-1.4-0.9c-0.1-0.6,0.2-1.3,0.9-1.4c0.9-0.2,1.9-0.2,2.9,0c2,0.5,3.6,2,4.1,4.1 c0.2,0.9,0.2,1.9,0,2.9c-0.1,0.6-0.8,1-1.4,0.9s-1-0.8-0.9-1.4c0.1-0.6,0.1-1.2,0-1.8c-0.3-1.2-1.2-2.1-2.3-2.3 C62.2,27.7,61.6,27.7,61,27.9z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M58.9,21.3c-0.6,0.1-1.3-0.2-1.4-0.9c-0.1-0.6,0.2-1.3,0.9-1.4l0,0c2.1-0.5,4.4-0.5,6.5,0 c4.5,1,8.1,4.6,9.1,9.1c0.5,2.2,0.5,4.4-0.1,6.5c-0.1,0.6-0.8,1-1.4,0.9s-1-0.8-0.9-1.4c0.4-1.8,0.5-3.7,0.1-5.5 c-0.8-3.7-3.7-6.5-7.4-7.4C62.6,20.9,60.7,20.9,58.9,21.3L58.9,21.3z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M60.5,15.3c-0.6,0.1-1.3-0.3-1.4-0.9C59,13.8,59.4,13.1,60,13c2.8-0.7,5.6-0.7,8.4-0.1 c5.8,1.4,10.3,5.9,11.6,11.7c0.6,2.8,0.6,5.6-0.1,8.4c-0.1,0.6-0.7,1.1-1.3,1s-1.1-0.7-1-1.3c0-0.1,0-0.1,0-0.2 c0.6-2.4,0.6-4.9,0.1-7.3c-1.1-4.9-5-8.8-9.9-9.9C65.4,14.7,62.9,14.7,60.5,15.3L60.5,15.3z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st1",
  cx: 57.4,
  cy: 35.1,
  r: 1.1
});

var SvgRoadMapIcon = function SvgRoadMapIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    "aria-hidden": "true",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRoadMapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/road-map-icon.cf0f5ef0.svg";
export { ForwardRef as ReactComponent };